var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('qrcodeScannerVue',{ref:"camara",attrs:{"qrbox":250,"fps":10},on:{"result":_vm.onScan}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }